import { Component, createContext } from 'react'

import { RecurlyContext } from './provider'

export const RecurlyElementsContext = createContext()

const { Provider } = RecurlyElementsContext

export default class Elements extends Component {
  constructor(props, context) {
    super(props, context)

    if (!context || !context.recurly) {
      throw new Error('<Elements> must be within a <RecurlyProvider> tree.')
    }

    const { onSubmit = () => ({}) } = props
    const { recurly } = this.context

    this.elements = recurly.Elements()
    this.elements.on('submit', (el) => onSubmit(el))
  }

  render() {
    const { children } = this.props
    return <Provider value={{ elements: this.elements }}>{children}</Provider>
  }
}

Elements.contextType = RecurlyContext
